import { motion } from 'framer-motion'
import React from 'react'
import { Row, Show } from '.'
import { classNameBuilder } from '@/helpers'

export interface ProgressBarProps {
  progress?: number
  multiBars?: { barClassName?: string; bgClassName?: string; weight?: number }[]
  className?: { wrapper?: string; bar?: string; divider?: string | false }
}
export const ProgressBar: React.FC<ProgressBarProps> = ({
  progress = 0,
  multiBars,
  className
}) => {
  const progressBars = multiBars || [{ barClassName: className?.bar }]
  const barsWeightSum = progressBars.reduce(
    (acc, { weight = 1 }) => acc + weight,
    0
  )
  const progressBreakpoints = progressBars.reduce<number[]>(
    (acc, { weight = 1 }, index) => [
      ...acc,
      (acc[index - 1] || 0) + (1 / barsWeightSum) * weight
    ],
    []
  )
  return (
    <Row
      className={classNameBuilder(
        'flex-nowrap overflow-hidden rounded-full',
        className?.wrapper ?? 'h-5'
      )}
    >
      {progressBars?.map(({ barClassName, bgClassName }, index) => {
        const progressStart = progressBreakpoints[index - 1] || 0
        const progressDuration = progressBreakpoints[index] - progressStart
        const currentProgress = (progress - progressStart) / progressDuration
        return (
          <React.Fragment key={`progressbar-${index}`}>
            <Show when={!!index && className?.divider !== false}>
              <div
                className={classNameBuilder(
                  'h-full w-0.5',
                  className?.divider ?? 'bg-[#431C80]'
                )}
              />
            </Show>
            <div
              className={classNameBuilder(
                'h-full',
                bgClassName ?? 'bg-[#FFFFFF33]'
              )}
              style={{ width: `${progressDuration * 100}%` }}
            >
              <motion.div
                animate={{
                  width:
                    currentProgress < 0
                      ? 0
                      : `${currentProgress > 1 ? 100 : currentProgress * 100}%`
                }}
                className={classNameBuilder(
                  'h-full w-0',
                  barClassName ??
                    className?.bar ??
                    'bg-gradient-to-r from-[#C0C0C0] to-[#C0C0C099]'
                )}
              />
            </div>
          </React.Fragment>
        )
      })}
    </Row>
  )
}

export default ProgressBar
